import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faStar } from '@fortawesome/pro-duotone-svg-icons/faStar'
import { toast, ToastOptions } from 'react-toastify'
import {
    ContentDossierFavoriteProps,
    ContentDossierFavoriteState,
} from '../types'
import { ToolbarButton } from '@/Components/Elements/StyledComponents/Buttons'
class ContentDossierFavorite extends React.Component<
    ContentDossierFavoriteProps,
    ContentDossierFavoriteState
> {
    toastOptions: ToastOptions

    constructor(props: ContentDossierFavoriteProps) {
        super(props)
        this.state = {
            favorite: this.props.favorite === true ? true : false,
        }
        this.favorOrUnfavorDossier = this.favorOrUnfavorDossier.bind(this)

        this.toastOptions = {
            position: 'bottom-center',
            autoClose: 2500,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
        }
    }

    favor() {
        const url = this.props.kedo
            .api()
            .getContentDossierFavoriteEndpoint(this.props.dossier.id, true)
        this.setState({ loading: true })

        this.props.kedo
            .api()
            .post(url)
            .then((response: any) =>
                this.setState({
                    favorite: true,
                    loading: false,
                })
            )
    }

    unfavor() {
        const url = this.props.kedo
            .api()
            .getContentDossierFavoriteEndpoint(this.props.dossier.id)
        this.setState({ loading: true })

        this.props.kedo
            .api()
            .delete(url)
            .then((response: any) =>
                this.setState({
                    favorite: false,
                    loading: false,
                })
            )
    }

    favorOrUnfavorDossier() {
        if (this.state.favorite === true) {
            this.unfavor()
            toast.success(
                this.props.kedo.t('dossier_errors.favorite_remove'),
                this.toastOptions
            )
        } else {
            this.favor()
            toast.success(
                this.props.kedo.t('dossier_errors.favorite_add'),
                this.toastOptions
            )
        }
    }

    render() {
        return (
            <ToolbarButton
                dense={this.props.size === 'sm'}
                variant={this.state.favorite ? 'contained' : 'outlined'}
                onClick={this.favorOrUnfavorDossier}
                title={this.props.kedo.t('Favorite')}
            >
                <FontAwesomeIcon icon={faStar} />
            </ToolbarButton>
        )
    }
}

export default ContentDossierFavorite
